module.exports = __webpack_public_path__ + "static/media/alpha-homora.f1cbf806.svg";